import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {InitiatePaymentComponent} from './initiate-payment/initiate-payment.component';
import {PaymentSuccessComponent} from './payment-success/payment-success.component';
import {PaymentFailureComponent} from './payment-failure/payment-failure.component';

const routes: Routes = [
    {
        path: '',
        component: InitiatePaymentComponent
    },
    {
        path: 'initiate',
        component: InitiatePaymentComponent
    }, 
    {
        path: 'success',
        component: PaymentSuccessComponent
    }, 
    {
    path: 'failure',
    component: PaymentFailureComponent
    }
];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forChild(routes)]
})
export class PaymentRoutingModule {
}
